<template>
<div class="mb-3 col-6 col-sm-3 col-md-2 item" :class="{'list-group-item': displayList}">
  <div class="thumbnail card">
    <div class="img-event intrinsic">
      <img :src="item.picUrl" alt="" class="grow thumbnail-image card-img-top intrinsic-item p-2">
    </div>
    <div class="card-body p-2">
      <router-link :to="'/product/' + item.id" tag="h6" class="card-title text-truncate d-block mb-1" :title="item.title"><a>{{ item.title }}</a></router-link>
      <div class="price-container mb-2">
        <span class="price-val">INR {{ (item.price * ( 1 + item.taxrate / 100)).toFixed(2)  }}</span>
        <!-- <small class="text-muted d-block tax-note">(Includes GST)</small> -->
      </div>
      <button class="btn btn-success btn-sm w-100" :disabled="item.quantity === 0 || isLoggedIn==false" @click="addItem">
        Add to cart
      </button>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapActions, mapGetters
} from 'vuex';
export default {
  props: ['item', 'displayList'],

  computed: {
    ...mapGetters(['showPrices']),
  },

  methods: {
    ...mapActions(['updateCart']),
    addItem() {
      const order = {
        item: Object.assign({}, this.item),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    }
  },
  filters: {
    shortDescription(value) {
      if (value && value.length > 100) {
        return value.substring(0, 100) + '...';
      } else {
        return value;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div.card {
  height: 100%;
}

.btn-sm {
  font-size: 0.7rem;
  padding: 0.25rem 0.4rem;
}

.card-title {
  font-size: 0.9rem;
  font-weight: bold;
}

.price-val {
  font-size: 0.8rem;
  font-weight: 600;
}

.tax-note {
  font-size: 0.7rem;
  line-height: 1;
}

.card-text {
  font-size: 0.875rem;
}

.remain {
  color: #d17581;
}

.grow {
  transition: all .2s ease-in-out;
}

.grow:hover {
  transform: scale(1.1);
}

.list-group-item {
  float: none;
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 1rem;
  border: 0;
  .thumbnail {
    display: inline-block;
    width: 100%;
  }
  .img-event {
    width: 20%;
    float: left;
    padding: 0 !important;
    margin: 0;
    height: auto;
  }

  .thumbnail-image {
    position: static;
  }

  .card-body {
    float: left;
    width: 80%;
    margin: 0;
  }

  @media (max-width: 767.98px) {
    .img-event {
      width: 30%;
      float: left;
      padding: 0 !important;
      margin: 0;
    }

    .card-body {
      float: left;
      width: 70%;
      margin: 0;
    }
  }
}




.item.list-group-item:before, .item.list-group-item:after
{
    display: table;
    content: " ";
}

.item.list-group-item:after {
  clear: both;
}
</style>
